var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5312 9.46895C14.825 9.7627 14.825 10.2377 14.5312 10.5283L8.53125 16.5314C8.2375 16.8252 7.7625 16.8252 7.47187 16.5314C7.18125 16.2377 7.17812 15.7627 7.47187 15.4721L12.9406 10.0033L7.46875 4.53145C7.175 4.2377 7.175 3.7627 7.46875 3.47207C7.7625 3.18145 8.2375 3.17832 8.52812 3.47207L14.5312 9.46895Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ec54f45093b9b8cc1d395ab16d21286b.svg";